export enum Frequency {
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTH = 'month'
}
